<odx-modal-header>
  <odx-area-header i18n="@@multiSelectGroupModal.header">Gruppe zuweisen</odx-area-header>
</odx-modal-header>
<odx-modal-content>
  @if (hasAlreadyGroupedItems) {
    <odx-inline-message variant="warning" i18n="@@group.modal.warning.alreadyGrouped" class="warning">
      Achtung: Einige der ausgewählten Elemente sind bereits einer Gruppe zugeordnet und werden in die neue Gruppe verschoben.
    </odx-inline-message>
  }
  <form odxForm [formGroup]="form">
    <odx-radio-group formControlName="groupMode">
      <div class="group-selection">
        <div class="option">
          <odx-radio-button value="existing" [disabled]="groups.length === 0"></odx-radio-button>
          <odx-form-field
            class="option-control"
            label="Bestehende Gruppe"
            i18n-label="@@multiSelectGroupModal.existingGroup.label"
          >
            <odx-select
              i18n-placeholder="@@multiSelectGroupModal.existingGroup.placeholder"
              placeholder="Gruppe auswählen"
              formControlName="selectedGroupId"
              odxFormFieldControl
            >
              @for (group of groups; track group.id) {
                <odx-select-option [value]="group.id">
                  {{ group.name }}
                </odx-select-option>
              }
            </odx-select>
          </odx-form-field>
        </div>
        <div class="option">
          <odx-radio-button value="new"></odx-radio-button>
          <odx-form-field class="option-control" label="Neue Gruppe" i18n-label="@@multiSelectGroupModal.newGroup.label">
            <input
              type="text"
              formControlName="newGroupName"
              odxFormFieldControl
              i18n-placeholder="@@multiSelectGroupModal.newGroup.placeholder"
              placeholder="Gruppennamen eingeben"
            />
          </odx-form-field>
        </div>
      </div>
    </odx-radio-group>
  </form>
</odx-modal-content>
<odx-modal-footer>
  <button odxButton variant="secondary" odxModalDismiss i18n="@@global.dismiss">Abbrechen</button>
  <button odxButton variant="primary" [disabled]="isConfirmDisabled" (click)="onConfirm()" i18n="@@group.modal.button.confirm">
    Bestätigen
  </button>
</odx-modal-footer>
